module.exports = __webpack_public_path__ + "img/index-box4-icon3.e7ecb214.png";